<a *ngIf="isAppointmentDetail" href="tel:+17325685030" class="support-call">

  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="19.83" height="24"
    viewBox="0 0 19.83 24">
    <path class="cls-1"
      d="M18.26,10.39c1.24.35,1.56.78,1.57,2v1.24c0,1.25-.33,1.68-1.56,2a4.39,4.39,0,0,1-.91,3,4.06,4.06,0,0,1-3.08,1.58c-.48,0-.95,0-1.43,0a1.32,1.32,0,0,0-1.32.53c-.57.81-2.59.75-3.26,0a1.45,1.45,0,0,1-.36-1.51A1.42,1.42,0,0,1,9.16,18.3c1-.07,2.09-.29,2.71.88,0,.07.17.12.26.12a16.92,16.92,0,0,0,2.47-.05,3.06,3.06,0,0,0,2.58-3.49,2,2,0,0,0-.36.4c-.2.45-.4.91-.58,1.38a2,2,0,0,1-1.7,1.16c.52-1.24,1-2.42,1.53-3.58.07-.16.36-.23.6-.37V13.18l-.37.14c-1,.45-1.17.32-1.17-.77s0-2,0-2.93a.63.63,0,0,0-.27-.48,8.87,8.87,0,0,1-3.41-2.62,9,9,0,0,1-3.61,2c-1.33.37-2.69.63-4.16,1v2.75c0,.24,0,.48,0,.72,0,.57-.33.75-.87.52s-1-.47-1.52-.7a1.43,1.43,0,0,0,1,2.14c.17,0,.38.27.48.47.74,1.47,1.41,3,2.18,4.42A8.11,8.11,0,0,0,6.3,21.52c1.94,1.94,4.23,1.94,6.11,0a1.81,1.81,0,0,1,1.82-.57c-2.07,3.37-5.82,4.24-8.67,1.33a16.41,16.41,0,0,1-3.28-5.49,1.8,1.8,0,0,0-1-1.1,2.57,2.57,0,0,1-1-3.43,3,3,0,0,0,.26-1A35.78,35.78,0,0,1,.81,6.66,8,8,0,0,1,7.93.16c.31,0,.61-.06.91-.11A1.89,1.89,0,0,1,10.9.76a.81.81,0,0,0,.59.3c4.65.3,6.6,3.38,6.77,7.32C18.29,9.05,18.26,9.73,18.26,10.39ZM2.62,12.14c0-1,0-2,0-3.05a.63.63,0,0,1,.68-.75A16.88,16.88,0,0,0,5,8.12c2.24-.4,4.4-1,6.06-2.71.32-.33.65-.2.87.14a7.35,7.35,0,0,0,3.62,2.74.78.78,0,0,1,.59.87c0,1,0,2,0,3,.21-.12.45-.19.45-.25A5.37,5.37,0,0,1,17.18,10a5.84,5.84,0,0,0,0-1.87c-.16-3.64-2.33-5.93-5.76-6a1.36,1.36,0,0,1-1.22-.55A1.2,1.2,0,0,0,8.87,1.1c-.21,0-.43.06-.64.09A7.16,7.16,0,0,0,1.79,6.76a25.13,25.13,0,0,0-.24,4.08C1.52,11.8,1.54,11.81,2.62,12.14Zm15.15,2.45c.92.05,1,0,1-.91v-1.3c0-.83-.13-.94-1-.83ZM9.88,20.34h0c.15,0,.33,0,.44,0a5,5,0,0,0,.64-.5c-.21-.18-.38-.44-.61-.51a1.74,1.74,0,0,0-1,0c-.2.05-.47.31-.47.48s.25.39.45.51S9.7,20.34,9.88,20.34Z" />
  </svg>

</a>


<!-- Appointment detail-->
<div *ngIf="isAppointmentDetail" class="ltr-component">
  <div class="wrapper">
    <div class="main-wrapper">

      <div class="container flex-grow-1 overflow-auto mt-5" style="margin-top:10px">
        <div>
          <!--<h4 class="fw-bold text-center mb-3 text-info">  {{'generic_text.welcome'|translate}} {{getPatientInfo.firstName |titlecase}} {{getPatientInfo.lastName |titlecase}}</h4>-->
          <h4 class="fw-bold text-center mb-3 text-info">

            <ng-container *ngIf="currentLang === 'ur'; else otherLang">
              {{getPatientInfo.firstName |titlecase}} {{getPatientInfo.lastName |titlecase}}
              {{'generic_text.welcome'|translate}}
            </ng-container>
            <ng-template #otherLang>
              {{'generic_text.welcome'|translate}} {{getPatientInfo.firstName |titlecase}} {{
getPatientInfo.lastName
              |titlecase
              }}
            </ng-template>
          </h4>
        </div>
        <div *ngIf="isiOS && (this.getPatientInfo.practiceCode == '100')" class="row justify-content-center mt-3">
          <div class="col-md-12">
            <div class="card">
              <div class=" p-0 ">
                <div class="mycontainer">
                  <div class="box">
                    <div style="color:#455a64">
                      <h5 class="fw-bold text-center mb-3 text-info"> {{'verifypatient.t360_heading'|translate}} TalkPHR 360</h5>
                      <p class="text-center mb-3" style="font-size:18px">
                        {{'verifypatient.t360_subtext1'|translate}} <strong>TalkPHR 360</strong>  {{'verifypatient.t360_subtext2'|translate}}
                      </p>

                      <div class="container">
                        <div class="row justify-content-center mt-4">
                          <!--<div class="col-lg-6 col-md-6 col-12 text-center mb-3 mb-md-0 custom-padding-1">
                      <button class="btn btn-primary w-100" (click)="opentalkPHR360()">
                        {{'button.open'|translate}} TalkPHR 360
                      </button>
                    </div>-->
                          <div class="col-lg-6 col-md-6 col-12 text-center mb-3 custom-padding-1">
                            <button class="btn btn-primary w-100" (click)="downloadtalkPHR360()">
                              {{'button.download'|translate}}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--<h4 class="fw-bold text-center mb-3 text-info">Continue in TalkPHR 360</h4>
  <h6 class="fw-bold text-center mb-3">Web check-in is no longer available.
  <br> To check-in, please use the app below. </h6>-->
        <h5 class="fw-bold text-center mb-3" [ngClass]="isiOS && (this.getPatientInfo.practiceCode == '100') ? 'mt-4' : ''">{{'verifypatient.appointment_detail'|translate}}</h5>
        <div class="row">
          <div class="col-md-6 mb-2">
            <div class="border-bottom d-flex align-items-center " [ngClass]="isiOS && (this.getPatientInfo.practiceCode == '100') ? 'p-1' : 'p-3'">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_771_467)">
                  <path d="M20 7.5C20.0019 7.04123 19.8775 6.59079 19.6405 6.198C19.4035 5.80521 19.0629 5.48521 18.6562 5.27305C18.2494 5.06089 17.7921 4.96474 17.3343 4.99515C16.8766 5.02555 16.436 5.18133 16.0609 5.44542C15.6858 5.70951 15.3905 6.07174 15.2075 6.49243C15.0245 6.91312 14.9608 7.37605 15.0234 7.83054C15.0859 8.28502 15.2723 8.71353 15.5622 9.06914C15.852 9.42474 16.2341 9.69374 16.6667 9.84667V13.3333C16.6667 14.6594 16.1399 15.9312 15.2022 16.8689C14.2645 17.8065 12.9928 18.3333 11.6667 18.3333C10.3406 18.3333 9.06882 17.8065 8.13113 16.8689C7.19345 15.9312 6.66667 14.6594 6.66667 13.3333V13.2667C8.0534 13.0655 9.32151 12.3722 10.2395 11.3135C11.1574 10.2548 11.664 8.90125 11.6667 7.5V2.5C11.6667 1.83696 11.4033 1.20107 10.9344 0.732233C10.4656 0.263392 9.82971 0 9.16667 0L6.66667 0V1.66667H9.16667C9.38768 1.66667 9.59964 1.75446 9.75592 1.91074C9.9122 2.06702 10 2.27899 10 2.5V7.5C10 8.60507 9.56101 9.66488 8.77961 10.4463C7.99821 11.2277 6.9384 11.6667 5.83333 11.6667C4.72826 11.6667 3.66846 11.2277 2.88706 10.4463C2.10565 9.66488 1.66667 8.60507 1.66667 7.5V2.5C1.66667 2.27899 1.75446 2.06702 1.91074 1.91074C2.06702 1.75446 2.27899 1.66667 2.5 1.66667H5V0H2.5C1.83696 0 1.20107 0.263392 0.732233 0.732233C0.263392 1.20107 0 1.83696 0 2.5L0 7.5C0.00267996 8.90125 0.509243 10.2548 1.4272 11.3135C2.34516 12.3722 3.61327 13.0655 5 13.2667V13.3333C5 15.1014 5.70238 16.7971 6.95262 18.0474C8.20286 19.2976 9.89856 20 11.6667 20C13.4348 20 15.1305 19.2976 16.3807 18.0474C17.631 16.7971 18.3333 15.1014 18.3333 13.3333V9.84667C18.8191 9.67493 19.2399 9.35731 19.5383 8.93725C19.8366 8.51719 19.9979 8.01522 20 7.5Z"
                        fill="#455A64" />
                </g>
                <defs>
                  <clipPath id="clip0_771_467">
                    <rect width="20" height="20" fill="white" />
                  </clipPath>
                </defs>
              </svg>

              <!--<h5 class="mb-0 ml-3 fw-bold text-info" *ngIf="getPatientInfo.providerFirstName=='ami' && getPatientInfo.providerLastName=='patel'"> {{getPatientInfo.providerFirstName}} {{getPatientInfo.providerLastName}}, NP</h5>-->
              <!--<ng-container *ngIf="getPatientInfo.providerFirstName === 'Albert' && getPatientInfo.providerLastName === 'Davis'; else otherProvider">-->
              <ng-container *ngIf="getPatientInfo.providerFirstName === 'AMI' && getPatientInfo.providerLastName === 'PATEL'; else otherProvider">
                <h5 class="mb-0 ml-3 fw-bold text-info">
                  {{getPatientInfo.providerFirstName}}
                  {{getPatientInfo.providerLastName}}, NP
                </h5>
              </ng-container>
              <ng-template #otherProvider>
                <h5 class="mb-0 ml-3 fw-bold text-info">
                  {{dr}}{{getPatientInfo.providerFirstName}}
                  {{getPatientInfo.providerLastName}}{{np}}
                </h5>
              </ng-template>
            </div>
          </div>
          <div class="col-md-6 mb-2">
            <div class="border-bottom d-flex align-items-center " [ngClass]="isiOS && (this.getPatientInfo.practiceCode == '100') ? 'p-1' : 'p-3'">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_771_471)">
                  <path d="M15.8333 1.66667H15V0.833333C15 0.61232 14.9122 0.400358 14.7559 0.244078C14.5996 0.0877974 14.3877 0 14.1667 0C13.9457 0 13.7337 0.0877974 13.5774 0.244078C13.4211 0.400358 13.3333 0.61232 13.3333 0.833333V1.66667H6.66667V0.833333C6.66667 0.61232 6.57887 0.400358 6.42259 0.244078C6.26631 0.0877974 6.05435 0 5.83333 0C5.61232 0 5.40036 0.0877974 5.24408 0.244078C5.0878 0.400358 5 0.61232 5 0.833333V1.66667H4.16667C3.062 1.66799 2.00296 2.1074 1.22185 2.88852C0.440735 3.66963 0.00132321 4.72867 0 5.83333L0 15.8333C0.00132321 16.938 0.440735 17.997 1.22185 18.7782C2.00296 19.5593 3.062 19.9987 4.16667 20H15.8333C16.938 19.9987 17.997 19.5593 18.7782 18.7782C19.5593 17.997 19.9987 16.938 20 15.8333V5.83333C19.9987 4.72867 19.5593 3.66963 18.7782 2.88852C17.997 2.1074 16.938 1.66799 15.8333 1.66667ZM1.66667 5.83333C1.66667 5.17029 1.93006 4.53441 2.3989 4.06557C2.86774 3.59673 3.50363 3.33333 4.16667 3.33333H15.8333C16.4964 3.33333 17.1323 3.59673 17.6011 4.06557C18.0699 4.53441 18.3333 5.17029 18.3333 5.83333V6.66667H1.66667V5.83333ZM15.8333 18.3333H4.16667C3.50363 18.3333 2.86774 18.0699 2.3989 17.6011C1.93006 17.1323 1.66667 16.4964 1.66667 15.8333V8.33333H18.3333V15.8333C18.3333 16.4964 18.0699 17.1323 17.6011 17.6011C17.1323 18.0699 16.4964 18.3333 15.8333 18.3333Z"
                        fill="#455A64" />
                  <path d="M10 13.75C10.6904 13.75 11.25 13.1904 11.25 12.5C11.25 11.8096 10.6904 11.25 10 11.25C9.30964 11.25 8.75 11.8096 8.75 12.5C8.75 13.1904 9.30964 13.75 10 13.75Z"
                        fill="#455A64" />
                  <path d="M5.8335 13.75C6.52385 13.75 7.0835 13.1904 7.0835 12.5C7.0835 11.8096 6.52385 11.25 5.8335 11.25C5.14314 11.25 4.5835 11.8096 4.5835 12.5C4.5835 13.1904 5.14314 13.75 5.8335 13.75Z"
                        fill="#455A64" />
                  <path d="M14.1665 13.75C14.8569 13.75 15.4165 13.1904 15.4165 12.5C15.4165 11.8096 14.8569 11.25 14.1665 11.25C13.4761 11.25 12.9165 11.8096 12.9165 12.5C12.9165 13.1904 13.4761 13.75 14.1665 13.75Z"
                        fill="#455A64" />
                </g>
                <defs>
                  <clipPath id="clip0_771_471">
                    <rect width="20" height="20" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <h5 class="mb-0 ml-3 text-info fw-light"> {{getPatientInfo?.visitDate | date}}</h5>
            </div>
          </div>
          <div class="col-md-6 mb-2">
            <div class="border-bottom d-flex align-items-center " [ngClass]="isiOS && (this.getPatientInfo.practiceCode == '100') ? 'p-1' : 'p-3'">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 19C5.03725 19 1 14.9628 1 10C1 5.03725 5.03725 1 10 1C14.9628 1 19 5.03725 19 10C19 14.9628 14.9628 19 10 19ZM10 2.5C5.8645 2.5 2.5 5.8645 2.5 10C2.5 14.1355 5.8645 17.5 10 17.5C14.1355 17.5 17.5 14.1355 17.5 10C17.5 5.8645 14.1355 2.5 10 2.5ZM13.75 10C13.75 9.58525 13.4148 9.25 13 9.25H10.75V5.5C10.75 5.08525 10.414 4.75 10 4.75C9.586 4.75 9.25 5.08525 9.25 5.5V10C9.25 10.4148 9.586 10.75 10 10.75H13C13.4148 10.75 13.75 10.4148 13.75 10Z"
                      fill="#455A64" />
              </svg>
              <h5 class="mb-0 ml-3 text-info">{{getPatientInfo?.timE_FROM}}</h5>
            </div>
          </div>
          <div class="col-md-6 mb-2">
            <div class="border-bottom d-flex align-items-center justify-content-between " [ngClass]="isiOS && (this.getPatientInfo.practiceCode == '100') ? 'p-1' : 'p-3'">
              <div class="d-flex">
                <span style="width: 20px;">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.50019 5.50195C8.9101 5.50195 8.33325 5.67788 7.8426 6.0075C7.35195 6.33712 6.96954 6.80561 6.74372 7.35374C6.51789 7.90187 6.45881 8.50502 6.57393 9.08691C6.68905 9.66881 6.97321 10.2033 7.39048 10.6228C7.80774 11.0424 8.33936 11.3281 8.91812 11.4438C9.49688 11.5595 10.0968 11.5001 10.642 11.2731C11.1871 11.0461 11.6531 10.6616 11.981 10.1683C12.3088 9.67496 12.4838 9.09499 12.4838 8.50169C12.4838 7.70611 12.1694 6.94312 11.6099 6.38056C11.0504 5.818 10.2915 5.50195 9.50019 5.50195ZM9.50019 10.0016C9.20514 10.0016 8.91672 9.9136 8.6714 9.74879C8.42607 9.58398 8.23486 9.34974 8.12195 9.07567C8.00904 8.8016 7.9795 8.50003 8.03706 8.20908C8.09462 7.91814 8.2367 7.65089 8.44534 7.44113C8.65397 7.23137 8.91978 7.08852 9.20916 7.03064C9.49854 6.97277 9.79849 7.00247 10.0711 7.11599C10.3437 7.22952 10.5767 7.42176 10.7406 7.66841C10.9045 7.91506 10.992 8.20505 10.992 8.50169C10.992 8.89948 10.8348 9.28098 10.5551 9.56226C10.2753 9.84354 9.89584 10.0016 9.50019 10.0016Z"
                          fill="#455A64" />
                    <path d="M9.5 18.9999C8.87191 19.0032 8.2522 18.8551 7.69274 18.568C7.13328 18.281 6.65037 17.8633 6.28444 17.3501C3.44182 13.4077 2 10.4439 2 8.5406C2 6.54071 2.79018 4.62273 4.1967 3.20859C5.60322 1.79445 7.51088 1 9.5 1C11.4891 1 13.3968 1.79445 14.8033 3.20859C16.2098 4.62273 17 6.54071 17 8.5406C17 10.4439 15.5582 13.4077 12.7156 17.3501C12.3496 17.8633 11.8667 18.281 11.3073 18.568C10.7478 18.8551 10.1281 19.0032 9.5 18.9999ZM9.5 2.63711C7.94288 2.6389 6.45004 3.2616 5.34898 4.36861C4.24793 5.47563 3.62858 6.97655 3.6268 8.5421C3.6268 10.0495 5.03879 12.837 7.60169 16.3909C7.81926 16.6922 8.1047 16.9375 8.43464 17.1066C8.76459 17.2757 9.12966 17.3638 9.5 17.3638C9.87034 17.3638 10.2354 17.2757 10.5654 17.1066C10.8953 16.9375 11.1807 16.6922 11.3983 16.3909C13.9612 12.837 15.3732 10.0495 15.3732 8.5421C15.3714 6.97655 14.7521 5.47563 13.651 4.36861C12.55 3.2616 11.0571 2.6389 9.5 2.63711Z"
                          fill="#455A64" />
                  </svg>
                </span>
                <h5 class="mb-0 ml-3 text-info">
                  <span>
                    <a href="https://www.google.com/maps/place/{{appointmentAddress}}, {{appointmentCity}}, {{appointmentState}} {{appointmentZip}}"
                       target="_blank">
                      {{appointmentAddress | titlecase}}, {{appointmentCity|titlecase}}, {{appointmentState}}
                      {{appointmentZip}}
                    </a>

                  </span>
                </h5>
              </div>

            </div>
          </div>
          <div class="col-md-6 mb-2">
            <div class="border-bottom d-flex align-items-center " [ngClass]="isiOS && (this.getPatientInfo.practiceCode == '100') ? 'p-1' : 'p-3'">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.6304 2.3627L16.8429 1.68041C15.9354 0.773196 14.4654 0.773196 13.5579 1.68041C13.5354 1.70291 12.1479 3.50984 12.1479 3.50984C11.2929 4.40956 11.2929 5.82662 12.1479 6.71884L13.0179 7.8135C11.9229 10.2952 10.2204 12.0047 7.82039 13.0244L6.72539 12.1471C5.83289 11.2849 4.40789 11.2849 3.51539 12.1471C3.51539 12.1471 1.70789 13.5342 1.68539 13.5567C0.777887 14.4639 0.777887 15.9335 1.64789 16.8032L2.39789 17.6654C3.26039 18.5276 4.42289 19 5.68289 19C11.4129 19 19.0029 11.4049 19.0029 5.68416C19.0029 4.43205 18.5304 3.26242 17.6304 2.3702V2.3627ZM5.68289 17.493C4.82789 17.493 4.04039 17.1781 3.50039 16.6307L2.75039 15.7685C2.44289 15.4611 2.42789 14.9588 2.72039 14.6364C2.72039 14.6364 4.51289 13.2568 4.53539 13.2343C4.84289 12.9269 5.38289 12.9269 5.69789 13.2343C5.72039 13.2568 7.22789 14.4639 7.22789 14.4639C7.43789 14.6289 7.71539 14.6739 7.96289 14.5764C11.0679 13.3918 13.2954 11.1724 14.5779 7.97095C14.6754 7.72352 14.6379 7.43861 14.4654 7.22118C14.4654 7.22118 13.2579 5.70665 13.2429 5.69166C12.9204 5.36926 12.9204 4.85192 13.2429 4.52952C13.2654 4.50703 14.6454 2.71509 14.6454 2.71509C14.9679 2.42268 15.4704 2.43018 15.8154 2.77507L16.6029 3.45736C17.1804 4.03468 17.5029 4.82193 17.5029 5.67666C17.5029 10.895 10.1754 17.493 5.68289 17.493Z"
                      fill="#455A64" />
              </svg>
              <h5 class="mb-0 ml-3 text-info">
                <a href={{phoneLink}}>{{getPatientInfo.practicePhone}}</a>
              </h5>
            </div>
          </div>
        </div>
        <!--<div class="container" *ngIf="isCancelRescheduleEnabled == 1">
    <div class="row justify-content-center mt-4">
      <div *ngIf="rescheduleCancel" class="col-lg-6 col-md-6 col-12 text-center mb-3 mb-md-0 custom-padding ">
        <button class="btn btn-outline-primary w-100"
          (click)="ConfirmCancelAppointment()">{{'verifypatient.cancel_Appt_header'|translate}}</button>
      </div>
      <div class="col-lg-6 col-md-6 col-12 text-center mb-3 custom-padding">
        <button class="btn btn-outline-primary w-100"
          (click)="ConfirmRescheduleAppointment()">{{'verifypatient.reschedule_Appt_header'|translate}}</button>
      </div>
    </div>
  </div>-->
        <div *ngIf="isAndroid || isiOS && (this.getPatientInfo.practiceCode != '100')" class="row justify-content-center">
          <div class="col-md-12">
            <div class="card">
              <div class=" p-0 ">
                <div class="mycontainer">
                  <div *ngIf="isiOS">
                    <a href="https://apps.apple.com/us/app/talkphr-360-carecloud/id6746710207" target="_blank" rel="noopener" style="text-decoration:none; color:inherit;">
                      <div class="box">
                        <label style="color:#455a64">
                          Try your new <br><span style="font-size:30px">Talk<strong>PHR</strong> 360</span>
                          <br>
                          <img width="150" class="mt-1" src="assets/images/app-store.png" alt="App Store" />
                        </label>
                      </div>
                    </a>
                  </div>
                  <div *ngIf="isAndroid">
                    <a href="https://play.google.com/store/apps/details?id=com.carecloud.primephr" target="_blank" rel="noopener" style="text-decoration:none; color:inherit;">
                      <div class="box">
                        <label style="color:#455a64">
                          Try your new <br><span style="font-size:30px">Talk<strong>PHR</strong> 360</span>
                          <br>
                          <img width="150" class="mt-1" src="assets/images/google-play.png" alt="play Store" />
                        </label>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>




      </div>
    </div>
  </div>

  <footer>

    <div class="container">
      <div class="row justify-content-center">
        <div *ngIf="rescheduleCancel" class="col-lg-6 col-md-6 col-12" style="padding: 0px 30px 0px 30px">
          <button *ngIf="!isiOS  || this.getPatientInfo.practiceCode != '100'" class="btn btn-primary w-100" type="button"
                  (click)="gotoVerify()">
            {{'verifypatient.get_started'|translate}}
          </button>
          <button *ngIf="isiOS  && this.getPatientInfo.practiceCode == '100'" class="btn btn-primary w-100" type="button"
                  (click)="gotoVerify()">
            {{'button.cont_web'|translate}}
          </button>
        </div>
      </div>
    </div>
  </footer>

</div>


<div *ngIf="!isAppointmentDetail">

  <form [formGroup]="profileForm">
    <div class="wrapper">
      <div class="container flex-grow-1 overflow-auto" style="margin-top:50px">

        <div class="form-group">
          <div class="btn-group d-flex w-100" id="checkin" role="group" aria-label="Basic example">
            <button type="button"
                    class="btn flex-fill"
                    [ngClass]="isDob ? 'btn-primary' : 'btn-outline-primary'"
                    (click)="ChangeCheckinType('dob')">
              {{'verifypatient.use_dob'|translate}}
            </button>
            <button type="button"
                    class="btn flex-fill"
                    [ngClass]="isScanLicense ? 'btn-primary' : 'btn-outline-primary'"
                    (click)="ChangeCheckinType('scan')">
              {{'verifypatient.driver_license'|translate}}
            </button>
          </div>



        </div>
        <!--<ul class="nav nav-tabs" role="tablist">
          <li class="nav-item" role="presentation">
            <a class="nav-link" [class.active]="isDob" (click)="ChangeCheckinType('dob')">
              Use DOB
            </a>
          </li>
          <li class="nav-item" role="presentation">
            <a class="nav-link" [class.active]="isScanLicense" (click)="ChangeCheckinType('scan')">
              Scan Driving License
            </a>
          </li>
        </ul>-->



        <div *ngIf="isDob">
          <h5 *ngIf="verifyPatientScreen" class="fw-bold text-center mb-4 fw-bold">
            {{'verifypatient.provide_dob_to_start_check_in'|translate}}
          </h5>
          <h5 *ngIf="cancelScreen" class="fw-bold text-center mb-4 fw-bold">
            {{'verifypatient.provide_dob_to_cancel'|translate}}
          </h5>
          <h5 *ngIf="rescheduleScreen" class="fw-bold text-center mb-4 fw-bold">
            {{'verifypatient.provide_dob_to_reschedule'|translate}}
          </h5>

          <div *ngIf="isLockScreen" class="main-info" style="font-size: 20px;text-transform: uppercase;">
            {{'verifypatient.session_locked'|translate}}
          </div>
          <div class="">

            <div class="form-row">
              <!--Audio play icon-->
              <!--<div (click)="test()">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#5bc5d0" class="bi bi-volume-up" viewBox="0 0 16 16">
          <path d="M11.536 14.01A8.47 8.47 0 0 0 14.026 8a8.47 8.47 0 0 0-2.49-6.01l-.708.707A7.48 7.48 0 0 1 13.025 8c0 2.071-.84 3.946-2.197 5.303z" />
          <path d="M10.121 12.596A6.48 6.48 0 0 0 12.025 8a6.48 6.48 0 0 0-1.904-4.596l-.707.707A5.48 5.48 0 0 1 11.025 8a5.48 5.48 0 0 1-1.61 3.89z" />
          <path d="M10.025 8a4.5 4.5 0 0 1-1.318 3.182L8 10.475A3.5 3.5 0 0 0 9.025 8c0-.966-.392-1.841-1.025-2.475l.707-.707A4.5 4.5 0 0 1 10.025 8M7 4a.5.5 0 0 0-.812-.39L3.825 5.5H1.5A.5.5 0 0 0 1 6v4a.5.5 0 0 0 .5.5h2.325l2.363 1.89A.5.5 0 0 0 7 12zM4.312 6.39 6 5.04v5.92L4.312 9.61A.5.5 0 0 0 4 9.5H2v-3h2a.5.5 0 0 0 .312-.11" />
        </svg>
      </div>-->

              <div class="col-md-12">
                <div class=" col-md-12 form-group">
                  <div class="  mb-2 border-bottom fw-bold">
                    <label style="font-size:20px;">
                      {{'verifypatient.month'|translate}}<span class="text-danger">*</span>
                    </label>
                    <div class="position-relative border-0 form-select form-select-custom">
                      <select formControlName="dobMonth" class="form-control text-capitalize border-0"
                              placeholder="Month" (change)="updateDays($event)">
                        <option value="" disabled selected>{{'verifypatient.select_month'|translate}}</option>
                        <option *ngFor="let month of months; let i = index" [value]="i+1">{{ month }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="mb-2">
                    <span id="f-zip-err" class="err"
                          *ngIf="profileForm.controls['dobMonth'].touched && profileForm.controls['dobMonth'].invalid">
                      <span class="err"
                            *ngIf="profileForm.controls['dobMonth'].errors && profileForm.controls['dobMonth'].errors.required">
                        {{'verifypatient.month_error_msg'|translate}}.
                      </span>
                    </span>
                  </div>
                </div>



                <div class=" col-md-12 form-group">
                  <div class=" mb-2 border-bottom fw-bold">
                    <label style="font-size:20px;">
                      {{'verifypatient.date_label'|translate}}<span class="text-danger">*</span>
                    </label>
                    <div class="position-relative pr-3 border-0 form-select form-select-custom">
                      <select formControlName="dobDay" class="form-control text-capitalize border-0">
                        <option value="" selected disabled>{{'verifypatient.select_date'|translate}}</option>
                        <option *ngFor="let day of daysInMonth" [value]="day">{{ day }}</option>
                      </select>

                    </div>
                  </div>
                  <div class="mb-2">
                    <span *ngIf="profileForm.controls['dobDay'].touched && profileForm.controls['dobDay'].invalid">
                      <span class="err"
                            *ngIf="profileForm.controls['dobDay'].errors && profileForm.controls['dobDay'].errors.required">
                        {{'verifypatient.day_error_msg'|translate}}.
                      </span>
                    </span>
                  </div>
                </div>


                <div class=" col-md-12 form-group">
                  <div class="  mb-2 border-bottom fw-bold">
                    <label style="font-size:20px;">
                      {{'verifypatient.year'|translate}}<span class="text-danger">*</span>
                    </label>
                    <div class="position-relative pr-3 border-0 form-select form-select-custom">
                      <select formControlName="dobyear" class="form-control text-capitalize border-0"
                              (change)="updateDays($event)">
                        <option value="" disabled selected>{{'verifypatient.select_year'|translate}}</option>
                        <option *ngFor="let year of years" [value]="year">{{ year }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="mb-2">
                    <span id="f-zip-err" class="err"
                          *ngIf="profileForm.controls['dobyear'].touched && profileForm.controls['dobyear'].invalid">
                      <span class="err"
                            *ngIf="profileForm.controls['dobyear'].errors && profileForm.controls['dobyear'].errors.required">
                        {{'verifypatient.year_error_msg'|translate}}.
                      </span>
                    </span>
                  </div>
                </div>
              </div>

            </div>


          </div>
          <div *ngIf="isiOS || isAndroid" class="row justify-content-center">
            <div class="col-md-12">
              <div class="card">
                <div class=" p-0 ">
                  <div class="mycontainer">
                    <div *ngIf="isiOS">
                      <a href="https://apps.apple.com/us/app/talkphr-360-carecloud/id6746710207" target="_blank" rel="noopener" style="text-decoration:none; color:inherit;">
                        <div class="box">
                          <label style="color:#455a64">
                            Try your new <br><span style="font-size:30px">Talk<strong>PHR</strong> 360</span>
                            <br>
                            <img width="150" class="mt-1" src="assets/images/app-store.png" alt="App Store" />
                          </label>
                        </div>
                      </a>
                    </div>
                    <div *ngIf="isAndroid">
                      <a href="https://play.google.com/store/apps/details?id=com.carecloud.primephr" target="_blank" rel="noopener" style="text-decoration:none; color:inherit;">
                        <div class="box">
                          <label style="color:#455a64">
                            Try your new <br><span style="font-size:30px">Talk<strong>PHR</strong> 360</span>
                            <br>
                            <img width="150" class="mt-1" src="assets/images/google-play.png" alt="play Store" />
                          </label>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Scan driving card start-->
        <div  *ngIf="isScanLicense && !isDobChecked" class="mt-5">
          <div class="row justify-content-center">
            <div class="col-md-12">
              <div class="card">
                <div class=" p-0 ">
                  <div class="mycontainer">
                    <div class="box">


                      <button type="button" class="btn btn-sm upload-btn w-100 px-0 d-flex justify-content-center align-items-center">
                        <input type="file" id="file" class="d-none" (change)="onChangeFileFront($event)"
                               accept="image/png, image/gif, image/jpeg, image/jpg">

                        <!--<label for="file" class="w-100 d-flex align-items-center m-0 justify-content-start justify-content-md-center">

                <svg width="45" height="45" viewBox="0 0 45 45" fill="#5bc5d0" xmlns="http://www.w3.org/2000/svg" class="me-3">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M36.0938 6.09375V13.5938C36.0938 14.37 36.7237 15 37.5 15C38.2763 15 38.9062 14.37 38.9062 13.5938V6.09375C38.9062 5.3175 38.2763 4.6875 37.5 4.6875C36.7237 4.6875 36.0938 5.3175 36.0938 6.09375Z" fill="#5bc5d0" />
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M33.75 11.25H41.25C42.0263 11.25 42.6562 10.62 42.6562 9.84375C42.6562 9.0675 42.0263 8.4375 41.25 8.4375H33.75C32.9737 8.4375 32.3438 9.0675 32.3438 9.84375C32.3438 10.62 32.9737 11.25 33.75 11.25Z" fill="#5bc5d0" />
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M26.25 5.625H17.0963C15.8531 5.625 14.7169 6.32812 14.1619 7.43813L12.3862 10.9912C12.3056 11.1487 12.1444 11.25 11.9662 11.25H7.5C4.65187 11.25 2.34375 13.5581 2.34375 16.4062V35.1562C2.34375 36.5231 2.8875 37.8356 3.85313 38.8031C4.82063 39.7687 6.13313 40.3125 7.5 40.3125H37.5C38.8669 40.3125 40.1794 39.7687 41.1469 38.8031C42.1125 37.8356 42.6562 36.5231 42.6562 35.1562C42.6562 29.4431 42.6562 19.2188 42.6562 19.2188C42.6562 18.4425 42.0263 17.8125 41.25 17.8125C40.4737 17.8125 39.8438 18.4425 39.8438 19.2188V35.1562C39.8438 35.7787 39.5963 36.3731 39.1575 36.8138C38.7169 37.2525 38.1225 37.5 37.5 37.5H7.5C6.8775 37.5 6.28312 37.2525 5.8425 36.8138C5.40375 36.3731 5.15625 35.7787 5.15625 35.1562V16.4062C5.15625 15.1125 6.20625 14.0625 7.5 14.0625H11.9662C13.2094 14.0625 14.3456 13.3594 14.9006 12.2494L16.6763 8.69625C16.7569 8.53875 16.9181 8.4375 17.0963 8.4375H26.25C27.0263 8.4375 27.6562 7.8075 27.6562 7.03125C27.6562 6.255 27.0263 5.625 26.25 5.625Z" fill="#5bc5d0" />
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M22.5 15.9375C17.5838 15.9375 13.5938 19.9275 13.5938 24.8438C13.5938 29.76 17.5838 33.75 22.5 33.75C27.4162 33.75 31.4062 29.76 31.4062 24.8438C31.4062 19.9275 27.4162 15.9375 22.5 15.9375ZM22.5 18.75C25.8638 18.75 28.5938 21.48 28.5938 24.8438C28.5938 28.2075 25.8638 30.9375 22.5 30.9375C19.1362 30.9375 16.4062 28.2075 16.4062 24.8438C16.4062 21.48 19.1362 18.75 22.5 18.75Z" fill="#5bc5d0" />
                </svg>

                <span class="text-container d-flex flex-column">
                  <span class="fw-semibold text-info" style="font-size: 18px;">
                    Scan Driver's License
                  </span>
                  <span class="text-muted" style="font-size: 14px;margin-left:5px">
                    Fast verification using your camera
                  </span>
                </span>

              </label>-->
                        <label for="file" class="w-100 d-flex flex-column align-items-center m-0">
                          <svg width="55" height="55" viewBox="0 0 45 45" fill="##10469f" xmlns="http://www.w3.org/2000/svg" class="mb-2">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M36.0938 6.09375V13.5938C36.0938 14.37 36.7237 15 37.5 15C38.2763 15 38.9062 14.37 38.9062 13.5938V6.09375C38.9062 5.3175 38.2763 4.6875 37.5 4.6875C36.7237 4.6875 36.0938 5.3175 36.0938 6.09375Z" fill="#10469f" />
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M33.75 11.25H41.25C42.0263 11.25 42.6562 10.62 42.6562 9.84375C42.6562 9.0675 42.0263 8.4375 41.25 8.4375H33.75C32.9737 8.4375 32.3438 9.0675 32.3438 9.84375C32.3438 10.62 32.9737 11.25 33.75 11.25Z" fill="#10469f" />
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M26.25 5.625H17.0963C15.8531 5.625 14.7169 6.32812 14.1619 7.43813L12.3862 10.9912C12.3056 11.1487 12.1444 11.25 11.9662 11.25H7.5C4.65187 11.25 2.34375 13.5581 2.34375 16.4062V35.1562C2.34375 36.5231 2.8875 37.8356 3.85313 38.8031C4.82063 39.7687 6.13313 40.3125 7.5 40.3125H37.5C38.8669 40.3125 40.1794 39.7687 41.1469 38.8031C42.1125 37.8356 42.6562 36.5231 42.6562 35.1562C42.6562 29.4431 42.6562 19.2188 42.6562 19.2188C42.6562 18.4425 42.0263 17.8125 41.25 17.8125C40.4737 17.8125 39.8438 18.4425 39.8438 19.2188V35.1562C39.8438 35.7787 39.5963 36.3731 39.1575 36.8138C38.7169 37.2525 38.1225 37.5 37.5 37.5H7.5C6.8775 37.5 6.28312 37.2525 5.8425 36.8138C5.40375 36.3731 5.15625 35.7787 5.15625 35.1562V16.4062C5.15625 15.1125 6.20625 14.0625 7.5 14.0625H11.9662C13.2094 14.0625 14.3456 13.3594 14.9006 12.2494L16.6763 8.69625C16.7569 8.53875 16.9181 8.4375 17.0963 8.4375H26.25C27.0263 8.4375 27.6562 7.8075 27.6562 7.03125C27.6562 6.255 27.0263 5.625 26.25 5.625Z" fill="#10469f" />
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M22.5 15.9375C17.5838 15.9375 13.5938 19.9275 13.5938 24.8438C13.5938 29.76 17.5838 33.75 22.5 33.75C27.4162 33.75 31.4062 29.76 31.4062 24.8438C31.4062 19.9275 27.4162 15.9375 22.5 15.9375ZM22.5 18.75C25.8638 18.75 28.5938 21.48 28.5938 24.8438C28.5938 28.2075 25.8638 30.9375 22.5 30.9375C19.1362 30.9375 16.4062 28.2075 16.4062 24.8438C16.4062 21.48 19.1362 18.75 22.5 18.75Z" fill="#10469f" />
                          </svg>

                          <span class="text-container d-flex flex-column align-items-center text-center">
                            <span class="fw-semibold text-info" style="font-size: 20px;">
                              {{'verifypatient.scan_title'|translate}}
                            </span>
                            <span class="text-muted" style="font-size: 17px; margin-left:0;">
                              {{'verifypatient.scan_title_text'|translate}}
                            </span>
                          </span>
                        </label>
                      </button>

                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-3">
                <span class="text-muted" style="font-size: 14px;">
                  {{'verifypatient.scan_disclaimer'|translate}}
                </span>
              </div>

            </div>
          </div>
          </div>
          <div *ngIf="isScanLicense && isDobChecked" class="form-row">

            <div class="col-md-12 mt-5">
              <!--<div class="devider mb-4">
      <span>{{ 'careteam.or' | translate }}</span>
    </div>-->
              <div class="col-md-12">
                <div class=" pb-2 border-bottom">

                  <button type="button" class="btn btn-sm upload-btn w-100 px-0 d-flex justify-content-center align-items-center">
                    <input type="file" id="file" class="d-none" (change)="onChangeFileFront($event)"
                           accept="image/png, image/gif, image/jpeg, image/jpg">

                    <label for="file" class="w-100 d-flex justify-content-center align-items-center">
                      <span class="file-button d-flex flex-column align-items-center justify-content-center">


                        <svg *ngIf="!isFrontPhotoUpload" width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M36.0938 6.09375V13.5938C36.0938 14.37 36.7237 15 37.5 15C38.2763 15 38.9062 14.37 38.9062 13.5938V6.09375C38.9062 5.3175 38.2763 4.6875 37.5 4.6875C36.7237 4.6875 36.0938 5.3175 36.0938 6.09375Z" fill="black" />
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M33.75 11.25H41.25C42.0263 11.25 42.6562 10.62 42.6562 9.84375C42.6562 9.0675 42.0263 8.4375 41.25 8.4375H33.75C32.9737 8.4375 32.3438 9.0675 32.3438 9.84375C32.3438 10.62 32.9737 11.25 33.75 11.25Z" fill="black" />
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M26.25 5.625H17.0963C15.8531 5.625 14.7169 6.32812 14.1619 7.43813L12.3862 10.9912C12.3056 11.1487 12.1444 11.25 11.9662 11.25H7.5C4.65187 11.25 2.34375 13.5581 2.34375 16.4062V35.1562C2.34375 36.5231 2.8875 37.8356 3.85313 38.8031C4.82063 39.7687 6.13313 40.3125 7.5 40.3125H37.5C38.8669 40.3125 40.1794 39.7687 41.1469 38.8031C42.1125 37.8356 42.6562 36.5231 42.6562 35.1562C42.6562 29.4431 42.6562 19.2188 42.6562 19.2188C42.6562 18.4425 42.0263 17.8125 41.25 17.8125C40.4737 17.8125 39.8438 18.4425 39.8438 19.2188V35.1562C39.8438 35.7787 39.5963 36.3731 39.1575 36.8138C38.7169 37.2525 38.1225 37.5 37.5 37.5H7.5C6.8775 37.5 6.28312 37.2525 5.8425 36.8138C5.40375 36.3731 5.15625 35.7787 5.15625 35.1562V16.4062C5.15625 15.1125 6.20625 14.0625 7.5 14.0625H11.9662C13.2094 14.0625 14.3456 13.3594 14.9006 12.2494L16.6763 8.69625C16.7569 8.53875 16.9181 8.4375 17.0963 8.4375H26.25C27.0263 8.4375 27.6562 7.8075 27.6562 7.03125C27.6562 6.255 27.0263 5.625 26.25 5.625Z" fill="black" />
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M22.5 15.9375C17.5838 15.9375 13.5938 19.9275 13.5938 24.8438C13.5938 29.76 17.5838 33.75 22.5 33.75C27.4162 33.75 31.4062 29.76 31.4062 24.8438C31.4062 19.9275 27.4162 15.9375 22.5 15.9375ZM22.5 18.75C25.8638 18.75 28.5938 21.48 28.5938 24.8438C28.5938 28.2075 25.8638 30.9375 22.5 30.9375C19.1362 30.9375 16.4062 28.2075 16.4062 24.8438C16.4062 21.48 19.1362 18.75 22.5 18.75Z" fill="black" />
                        </svg>


                        <div *ngIf="isFrontPhotoUpload" class="mb-3">
                          <img class="img-fluid" [src]="defaultImagefront" height="155" width="231">
                        </div>


                        <span *ngIf="!isFrontPhotoUpload" class="text-muted mt-2">
                          {{'verifypatient.driving_license' | translate}}
                        </span>
                        <span *ngIf="isFrontPhotoUpload" class="text-muted mt-2">
                          {{'verifypatient.driving_license_retake' | translate}}
                        </span>
                      </span>
                    </label>
                  </button>
                </div>
                <div class="mt-3">
                  <span class="text-muted" style="font-size: 14px;">
                    {{'verifypatient.retakeInfo'|translate}}
                  </span>
                </div>
              </div>
            </div>
          </div>
       

        <!-- Scan driving card end -->


      </div>
    </div>

    <footer>

      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-6 col-md-6 col-12" style="padding: 0px 30px 0px 30px">
            <button *ngIf="verifyPatientScreen" class="btn btn-primary w-100" type="button"
              (click)="onSubmit('checkin')">{{'verifypatient.good_to_go'|translate}}</button>
            <button *ngIf="cancelScreen" class="btn btn-primary w-100" type="button"
              (click)="onSubmit('cancel')">{{'verifypatient.cancel_Appt_header'|translate}}</button>
            <button *ngIf="rescheduleScreen" class="btn btn-primary w-100" type="button"
              (click)="onSubmit('reschedule')">{{'verifypatient.reschedule_Appt_header'|translate}}</button>
          </div>
        </div>
      </div>


    </footer>
  </form>
</div>

<div *ngIf="showThanksScreen" class="wrapper" style="margin-top:120px">
  <div class="container flex-grow-1 overflow-auto text-center">
    <div class="image mt-5">
      <i class="fas fa-calendar-check" style="font-size: 50px; color: #5bc5d0;"></i>
    </div>

    <div class="mb-5">
      <h2 class="mt-5">{{'verifypatient.thanks'|translate}}!</h2>
      <p>{{'verifypatient.please_wait_confirm_appointment'|translate}}</p>
    </div>

    <div class="spinner-container">
      <div style="color: #5bc5d0" class="la-ball-fussion la-2x">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="mt-5">
      <p>{{'verifypatient.contact_us'|translate}} <span class="text-info"> {{getPatientInfo.practicePhone}}</span></p>
    </div>
  </div>

  <div
    style=" height: 50px; position: fixed; z-index: 3; bottom: 0; background: #fff; width: 100%; display: flex; align-items: center; margin-left:-16px">
    <div>
    </div>
  </div>
</div>

<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="linkexpire-model">

  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-danger"><strong> {{'verifypatient.Link_is_expired'|translate}}</strong>
        </h5>
        <!--<p class="mb-0">Either the form is already filled once or the specific appointment time is passed.</p>-->
        <p class="mb-0">
          {{'verifypatient.Link_expired_info'|translate}}
        </p>
      </div>
    </div>
  </div>
</div>


<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="PreviousDayAppointment_model">

  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-danger"><strong> Appointment Deatils</strong></h5>
        <p class="mb-0">Your Appointment Time has been passed</p>
      </div>
    </div>
  </div>
</div>


<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="incorrectinfo-model">

  <!--text updated as per Sir Adeel CTO-->
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-danger">
          <strong>{{'verifypatient.Incorrect_information'|translate}}</strong>
        </h5>
        <h6 class="font-weight-bolder mb-3 ">{{'verifypatient.Credentials_do_not_match_our_records'|translate}}</h6>
        <p class="mb-3">
          {{'verifypatient.Please_check'|translate}}
          <span *ngIf="!getPatientInfo.practicePhone"> {{'verifypatient.office'|translate}}</span>
          <span *ngIf="getPatientInfo.practicePhone">
            {{'verifypatient.at'|translate}} <a href={{phoneLink}} class="text-info"
              style="direction: ltr; display: inline-block;">{{getPatientInfo.practicePhone}}</a>
          </span> {{'verifypatient.if_you_need_assistance'|translate}}
        </p>
        <button type="button" data-toggle="modal" data-dismiss="modal" id="closeDeleteFamilyHistory"
          class="btn btn-primary ">
          {{'button.ok'|translate}}
        </button>
      </div>
    </div>
  </div>
</div>

<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="incorrectinfoLicense-model">

  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-danger">
          <strong>{{'verifypatient.Incorrect_information'|translate}}</strong>
        </h5>
        <h6 class="font-weight-bolder mb-3 ">{{'verifypatient.dob_notmatched'|translate}}</h6>
        <p class="mb-3">
          {{'verifypatient.dob_notmatched_body'|translate}}
        </p>
        <button type="button" data-toggle="modal" data-dismiss="modal" id="closeDeleteFamilyHistory"
                class="btn btn-primary ">
          {{'button.ok'|translate}}
        </button>
      </div>
    </div>
  </div>
</div>

<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="cardMissing-model">

  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-danger">
          <strong>{{'verifypatient.cardRequired'|translate}}</strong>
        </h5>
        <h6 class="font-weight-bolder mb-3 ">{{'verifypatient.cardRequired_body'|translate}}</h6>
        <!--<p class="mb-3">
          Please upload the correct license or enter your DOB manually.
        </p>-->
        <button type="button" data-toggle="modal" data-dismiss="modal" id="closeDeleteFamilyHistory"
                class="btn btn-primary ">
          {{'button.ok'|translate}}
        </button>
      </div>
    </div>
  </div>
</div>

<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="scanFail-model">

  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-danger"><strong>{{'verifypatient.unable_scan'|translate}}</strong></h5>
        <h6 class="font-weight-bolder mb-3 ">{{'verifypatient.unable_scan_text'|translate}}</h6>
        <button type="button" data-toggle="modal" data-dismiss="modal" id="closeDeleteFamilyHistory"
          class="btn btn-primary " (click)="isDob=true;isScanLicense=false">
          {{'button.ok'|translate}}
        </button>
      </div>
    </div>
  </div>
</div>

<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="language-modal">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{'button.change_language' | translate}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body ">
        <div class="row">
          <div class="col">
            <div class=" d-flex justify-content-left align-items-end" (click)="selectLanguage('en')"
              style="margin-top:10px">
              <img width="32" class="mr-3" src="assets/images/america-flag.png" />English
            </div>

            <div class="devider" style="margin-bottom:25px"> </div>
            <div class=" d-flex justify-content-left align-items-end" (click)="selectLanguage('es')">
              <img width="32" class="mr-3" src="assets/images/spanish.png" />Spanish
            </div>

            <div class="devider" style="margin-bottom:25px"></div>
            <div class=" d-flex justify-content-left align-items-end" (click)="selectLanguage('hi')"
              style="margin-bottom:12px">
              <img width="32" class="mr-3" src="assets/images/india_flag.png" />Hindi
            </div>

            <div class="devider" style="margin-bottom:25px"></div>
            <div class=" d-flex justify-content-left align-items-end" (click)="selectLanguage('ur')"
              style="margin-bottom:12px">
              <img width="32" class="mr-3" src="assets/images/pakistan.png" />Urdu
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade in modal-alert bd-example-modal-sm" id="confirmCancelModal" tabindex="-1" role="dialog"
  data-backdrop="static" data-keyboard="false">

  <div class="modal-dialog modal-dialog-centered">

    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{'verifypatient.cancel_Appt_header'|translate}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-3">
        <p class="text-left" [ngClass]="{'text-left': !isRTL, 'text-right': isRTL}">
          {{'verifypatient.cancelConfirmAppt'|translate}}</p>
        <div class="text-center">
          <button type="button" class="btn btn-outline-primary" [ngClass]="{'mr-3': !isRTL, 'ml-3': isRTL}"
            data-dismiss="modal" (click)="gotoCancelAppointmentScreen()">
            {{'button.yes'|translate}}
          </button>
          <button class="btn btn-primary" data-dismiss="modal">
            {{'button.no'|translate}}
          </button>
        </div>

      </div>
    </div>
  </div>

</div>


<!--Confirm Reschedule modal start-->

<div class="modal fade in modal-alert bd-example-modal-sm" id="confirmRescheduleModal" tabindex="-1" role="dialog"
  data-backdrop="static" data-keyboard="false">

  <div class="modal-dialog modal-dialog-centered">

    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{'verifypatient.reschedule_Appt_header'|translate}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-3">
        <p class="text-left" [ngClass]="{'text-left': !isRTL, 'text-right': isRTL}">
          {{'verifypatient.rescheduleConfirmAppt'|translate}}</p>
        <div class="text-center">
          <button type="button" class="btn btn-outline-primary" [ngClass]="{'mr-3': !isRTL, 'ml-3': isRTL}"
            data-dismiss="modal" (click)="gotoRescheduleScreen()">
            {{'button.yes'|translate}}
          </button>
          <button class="btn btn-primary" data-dismiss="modal">
            {{'button.no'|translate}}
          </button>
        </div>

      </div>
    </div>
  </div>

</div>
<!--Confirm Reschedule modal end-->

<div class="modal fade in modal-alert bd-example-modal-sm" id="rescheduleModal" tabindex="-1" role="dialog"
  data-backdrop="static" data-keyboard="false">

  <div class="modal-dialog modal-dialog-centered">

    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{'verifypatient.reschedule_Appt_header'|translate}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="gotoHome()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-3">
        <p class="text-center">{{'verifypatient.cancelrescheduleAppt'|translate}}</p>
        <div class="text-center">
          <button type="button" class="btn btn-primary" data-dismiss="modal"
            (click)="rescheduleAfterCancel()">{{'verifypatient.reschedule_Appt_header'|translate}}</button>
        </div>

      </div>
    </div>
  </div>

</div>

<div class="modal fade in modal-alert bd-example-modal-sm" id="CancelrescheduleModal" tabindex="-1" role="dialog"
  data-backdrop="static" data-keyboard="false">

  <div class="modal-dialog modal-dialog-centered">

    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{'verifypatient.reschedule_Appt_header'|translate}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-3">
        <p class="text-center">{{'verifypatient.cancelrescheduleAppt'|translate}}</p>
        <div class="text-center">
          <button type="button" class="btn btn-primary" data-dismiss="modal"
            (click)="rescheduleAfterCancel()">{{'verifypatient.reschedule_Appt_header'|translate}}</button>
        </div>

      </div>
    </div>
  </div>

</div>

<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="checkinNotAllowed-model">

  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-danger"><strong>Check-in Opens on Your Appointment Date</strong></h5>
        <h6 class="mb-3">Check-in is only available on your appointment date. Please return on {{getPatientInfo?.visitDate | date}}  to complete your check-in.</h6>
        <button type="button" data-toggle="modal" data-dismiss="modal" id="closeDeleteFamilyHistory"
                class="btn btn-primary">
          Ok
        </button>
      </div>
    </div>
  </div>
</div>
